import { render, staticRenderFns } from "./select-schule.vue?vue&type=template&id=30130494&lang=pug&"
import script from "./select-schule.vue?vue&type=script&lang=js&"
export * from "./select-schule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports